<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.410093 0.410734C0.73553 0.0852972 1.26317 0.0852972 1.5886 0.410734L5.99935 4.82148L10.4101 0.410734C10.7355 0.0852972 11.2632 0.0852972 11.5886 0.410734C11.914 0.736171 11.914 1.26381 11.5886 1.58925L7.17786 5.99999L11.5886 10.4107C11.914 10.7362 11.914 11.2638 11.5886 11.5892C11.2632 11.9147 10.7355 11.9147 10.4101 11.5892L5.99935 7.1785L1.5886 11.5892C1.26317 11.9147 0.73553 11.9147 0.410093 11.5892C0.0846564 11.2638 0.0846564 10.7362 0.410093 10.4107L4.82084 5.99999L0.410093 1.58925C0.0846564 1.26381 0.0846564 0.736171 0.410093 0.410734Z"
            :fill="iconFill"
        />
    </g>
</template>
<script>
export default {
    name: "CloseX1212",
    props: {
        iconFill: {
            type: String,
            default: "#DA1E28",
        },
    },
};
</script>
